import { AccountActivityEntry } from "@/features/account/types";

/**
 * Builds the one line summary shown against an activity entry. The API returns
 * structured data rather than prose, so the wording lives here.
 */
export function activitySummary(activity: AccountActivityEntry): string {
  const ticket = activity.ticketTitle ?? activity.ticketKey;

  switch (activity.type) {
    case "TicketCreated":
      return ticket ? `Raised “${ticket}”` : "Raised a ticket";
    case "TicketResolved":
      return ticket ? `Resolved “${ticket}”` : "Resolved a ticket";
    case "TicketAssigned":
      return ticket ? `Assigned “${ticket}”` : "Was assigned a ticket";
    case "CommentAdded":
      return ticket ? `Commented on “${ticket}”` : "Added a comment";
    case "ProjectJoined":
      return `Joined ${activity.projectName}`;
    default:
      return activity.projectName;
  }
}
